import React from 'react';
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import { makeStyles } from '@material-ui/core/styles';
import { formatNumber } from './utils/formatDashboard';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    height: '100%',
  },
}));

const TransferStatsSection = ({ transfers, loading }) => {
  const classes = useStyles();

  const chartData = transfers
    ? [
        { name: 'Total', value: transfers.total },
        { name: 'Completed', value: transfers.completed },
        { name: 'Pending', value: transfers.pending },
        { name: 'Failed', value: transfers.failed },
        { name: 'Last 7 Days', value: transfers.last7Days },
        { name: 'Last 30 Days', value: transfers.last30Days },
      ]
    : [];

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardHeader title="Transfer Statistics" />
      <CmtCardContent>
        {loading ? (
          <Skeleton variant="rect" height={200} />
        ) : (
          <ResponsiveContainer width="100%" height={200}>
            <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 11 }} />
              <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 11 }} tickFormatter={formatNumber} />
              <Tooltip formatter={(v) => formatNumber(v)} labelStyle={{ color: '#333' }} />
              <Bar dataKey="value" fill="#0795F4" barSize={24} radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </CmtCardContent>
    </CmtCard>
  );
};

export default TransferStatsSection;
